// extracted by mini-css-extract-plugin
module.exports = {"textAboveButton":"ReservationButton_textAboveButton__FGRdS","wrapper":"ReservationButton_wrapper__dPv45","icon":"ReservationButton_icon__wdWpF"};